import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const EarlyAccessForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    company: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { t } = useTranslation();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    await new Promise(resolve => setTimeout(resolve, 1500));
    
    setIsSubmitting(false);
    setIsSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ email: '', company: '' });
    }, 3000);
  };

  if (isSubmitted) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="bg-success/10 border border-success/20 rounded-lg p-8 text-center"
      >
        <div className="w-16 h-16 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2 }}
          >
            ✓
          </motion.div>
        </div>
        <h3 className="text-xl font-bold text-success mb-2">
          Thank you for your interest!
        </h3>
        <p className="text-success/80">
          We'll notify you as soon as our products are available.
        </p>
      </motion.div>
    );
  }

  return (
    <motion.form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
    >
      <div className="space-y-4">
        <Input
          type="email"
          name="email"
          placeholder={t('products.earlyAccess.emailPlaceholder')}
          value={formData.email}
          onChange={handleInputChange}
          required
          className="bg-white/10 border-white/20 text-white placeholder-white/60"
        />
        
        <Input
          type="text"
          name="company"
          placeholder={t('products.earlyAccess.companyPlaceholder')}
          value={formData.company}
          onChange={handleInputChange}
          required
          className="bg-white/10 border-white/20 text-white placeholder-white/60"
        />
        
        <Button
          type="submit"
          variant="default"
          size="lg"
          fullWidth
          disabled={isSubmitting}
          className="bg-accent hover:bg-accent/90 text-accent-foreground"
          iconName={isSubmitting ? 'Loader2' : 'ArrowRight'}
          iconPosition="right"
        >
          {isSubmitting ? 'Submitting...' : t('products.earlyAccess.submit')}
        </Button>
      </div>
      
      <p className="text-xs text-primary-foreground/60 mt-4 text-center">
        No spam, unsubscribe at any time. We respect your privacy.
      </p>
    </motion.form>
  );
};

export default EarlyAccessForm;